import { render, staticRenderFns } from "./state2.vue?vue&type=template&id=18d486dd&scoped=true"
import script from "./state2.vue?vue&type=script&lang=js"
export * from "./state2.vue?vue&type=script&lang=js"
import style0 from "./state2.vue?vue&type=style&index=0&id=18d486dd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d486dd",
  null
  
)

export default component.exports